import React, { Suspense, useState } from "react";
import Container from "../Container/Container";
import RoadmapCanvas from "./RoadmapCanvas";
import SectionTitle from "../SectionTitle/SectionTitle";
import { useTranslation } from "react-i18next";
import { InView } from "react-intersection-observer";

const Roadmap = () => {
    const { t } = useTranslation();

    const [show, setShow] = useState(false);

    const onShow = (inView: boolean, entry: IntersectionObserverEntry) => {
        if (!show && inView) {
            setShow(true);
        }
    };

    return (
        <Suspense>
            <InView onChange={onShow}>
                {show && (
                    <Container>
                        <SectionTitle text={t("landing.roadmap.title")} gradientText="Sairus" />
                        <RoadmapCanvas />
                    </Container>
                )}
            </InView>
        </Suspense>
    );
};

export default Roadmap;
